import React, { createContext, useState, useEffect, ReactNode, useCallback, useContext } from 'react';
import { IDetalheArmazenamento, IPercentage, ITamanhoArmazenamento } from '../../interfaces/armazenagem';
import { getDetalheStorage, getStorage } from '../../services/modules/administracao';

interface IStorageContext {
    storage: ITamanhoArmazenamento | undefined;
    detalhes: IDetalheArmazenamento[] | undefined;
    progress: IPercentage | undefined;
    isStorageFull: boolean;
    loading: boolean;
    error: string | null;
    fetchStorageData: () => Promise<void>;
}

const StorageContext = createContext({} as IStorageContext);

interface StorageProviderProps {
    children: ReactNode;
}

export const StorageProvider: React.FC<StorageProviderProps> = ({ children }) => {
    const [storage, setStorage] = useState<ITamanhoArmazenamento | undefined>(undefined);
    const [progress, setProgress] = useState<IPercentage | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
     const [detalhes, setDetalhes] = useState<IDetalheArmazenamento[] | undefined>(undefined);

   const fetchStorageData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const [responseStorage, responseDetalhe] = await Promise.all([
                getStorage(),
                getDetalheStorage()
            ]);
            
            const dataStorage = responseStorage?.data;
            const dataDetalhe = responseDetalhe?.data;

            if (dataStorage && dataDetalhe) {

                const total = dataStorage.tamanhoArmazenamentoContratadoEmMB;
                const used = dataStorage.tamanhoArmazenadoEmMB;
                let percentage = (used / total) * 100;

                if (percentage > 0 && percentage < 1) {
                    percentage = 1;
                } else {
                    percentage = Math.round(percentage);
                }

                setStorage({
                    tamanhoArmazenadoEmMB: used,
                    tamanhoArmazenamentoContratadoEmMB: total,
                });
                
                setProgress({
                    percentage: percentage,
                    percentageLimit: 90,
                });
                setDetalhes(dataDetalhe);
            } else {
                setError('Dados de armazenamento não disponíveis.');
            }

        } catch (err) {
            console.error('Falha ao buscar dados de armazenamento', err);
            setError('Falha ao carregar dados de armazenamento.');
        } finally {
            setLoading(false);
        }
    }, []); 

    useEffect(() => {
        fetchStorageData();
    }, [fetchStorageData]);


    const isStorageFull = progress ? progress.percentage >= progress.percentageLimit : false;

    return (
        <StorageContext.Provider value={{ storage, progress, detalhes, isStorageFull, loading, error, fetchStorageData }}>
            {children}
        </StorageContext.Provider>
    );
};

export const useStorage = () => {
    const context = useContext(StorageContext);
    if (context === undefined) {
        throw new Error('useStorage deve ser usado dentro de um StorageProvider');
    }
    return context;
};